module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"components":{"pager":{"first":"First","previous":"Previous","next":"Next","last":"Last","page":"Page","outOf":"out of"}}},"it":{"components":{"pager":{"first":"Prima","previous":"Prec.","next":"Succ.","last":"Ultima","page":"Pagina","outOf":"di"}}}}')
  delete Component.options._Ctor
}
